import { default as jQuery } from 'jquery'

let toggleElementSelector = '.toggle-collapse-trigger';

const hideElement = (elementSelector) => {
  jQuery(elementSelector).removeClass('block');
  jQuery(elementSelector).addClass('hidden');
}

const showElement = (elementSelector) => {
  jQuery(elementSelector).removeClass('hidden');
  jQuery(elementSelector).addClass('block');
}

// Toggle menu on when clicking on toggle element
jQuery(document).on('click', toggleElementSelector, () => {
  let elementSelector = jQuery(toggleElementSelector).attr('data-collapse-target');

  if (jQuery(elementSelector).hasClass('hidden')) return showElement(elementSelector);

  hideElement(elementSelector);
});
